// extracted by mini-css-extract-plugin
module.exports = {"Transcript":"admin-portal__Transcript__Transcript"};